// GENERATED by scripts/build-icons.mjs from icons/lock-open.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const LockOpen = createIcon('lock-open', [
  ['rect', { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2" }],
  ['path', { d: "M7 11V7a5 5 0 0 1 9.9-1" }],
])
